import React, { useEffect, useState } from "react";
import api from "../../../common/api";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { ISubject } from "../../../common/types";
import Modal from "react-bootstrap/Modal";
import SubjectPictureUpload from "./SubjectPictureUpload";

interface EditSubjectProps {
  show: boolean;
  onHide: () => void;
  subject: ISubject;
  onSubjectUpdate: (subject: ISubject) => void;
}

const EditSubjectModal: React.FC<EditSubjectProps> = ({
  show,
  onHide,
  subject,
  onSubjectUpdate,
}) => {
  const [name, setName] = useState(subject.name);

  useEffect(() => {
    setName(subject.name);
  }, [subject]);

  const handleNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setName(event.target.value);
  };

  const handleUpdate = async () => {
    try {
      const response = await api.put(`/subjects/${subject.id}/`, { name });
      onSubjectUpdate(response.data);
      toast.success("Ime predmeta promijenjeno");
    } catch (error) {
      console.log(error);
      toast.error("Greška prilikom promjene imena predmeta");
    }
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Promijeni predmet</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          <label htmlFor="name" className="form-label">
            Naziv
          </label>
          <input
            type="text"
            className="form-control"
            id="name"
            value={name}
            onChange={handleNameChange}
          />
        </div>
        <div className="mb-3">
          <SubjectPictureUpload // Use the component
            subjectId={subject.id}
            initialImageUrl={subject.picture}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-primary" onClick={onHide}>
          Odustani
        </Button>
        <Button variant="primary" onClick={handleUpdate}>
          Promijeni
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditSubjectModal;
